import { render, staticRenderFns } from "./ResearchReportChartListItem.vue?vue&type=template&id=63c9d526&scoped=true"
import script from "./ResearchReportChartListItem.vue?vue&type=script&lang=js"
export * from "./ResearchReportChartListItem.vue?vue&type=script&lang=js"
import style0 from "./ResearchReportChartListItem.vue?vue&type=style&index=0&id=63c9d526&prod&lang=scss&scoped=true"
import style1 from "./ResearchReportChartListItem.vue?vue&type=style&index=1&id=63c9d526&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c9d526",
  null
  
)

export default component.exports